<template>
    <div id="content">
        <div class="container">
            <div class="card card-payment">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ payment_status == 1 ? $t('payment_confirmation') : $t('payment_unsuccess') }}</span>
                    </h5>

                    <div class="card-content">
                        <div class="payment-status">
                            <img src="/themes/ito/images/get-rewarded.svg" alt="" v-if="payment_status == 1">
                            <img src="/themes/ito/images/emoticon-24.svg" alt="" v-else>
                            <div class="mt-3" v-html="payment_status == 1 ? $t('payment_success_noti') : $t('payment_unsuccess_noti')"></div>
                            <div class="d-flex justify-content-center gap-3 mt-3">
                                <button class="ito-btn" :class="payment_status == 1 ? 'ito-btn-primary' : 'ito-btn-light'" @click="goHome">{{ isMobile ? 'Back to app' : $t('back_to_home') }}</button>
                                <button class="ito-btn ito-btn-primary" @click="$router.push({ name: 'upgrade_account' })" v-if="payment_status === 0">{{ $t('try_again') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import { paymentDetail } from "../../models/payment";
import { soundClick } from "../../utils/utils";

export default {
    name: "PaymentDetail",
    title: 'Payment detail',

    data() {
        const invoice = this.$route.query.invoice || '';
        return {
            invoice: invoice,
            payment_status: '',
            isMobile: false
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }
            return this.user
        })
    },

    created() {
        this.fetch();
    },

    mounted() {
        if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
            this.isMobile = false;
        } else {
            this.isMobile = true;
        }
    },
    watch: {},

    methods: {
        fetch() {
            const that = this;

            axios.all([
                paymentDetail({
                    invoice: that.invoice,
                }),
            ]).then(axios.spread((response) => {
                that.isLoading = false;
                if (response.data.code != 0) {
                    return;
                }
                that.payment_status = response.data.results.status
                if (that.payment_status === 1) {
                    //post mess to app
                    console.log("payment-done");
                    if (typeof appHandler !== 'undefined') {
                        appHandler.postMessage('payment-done');
                    }
                }
            }));
        },

        getSoundClick() {
            soundClick();
        },

        goHome() {
            if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
                window.location.href = '/'
            } else {
                window.location = 'ismart://openApp?data=payment-success&id=0'
            }
        }

    }
}
</script>

<style scoped>
.card-payment .card-content {
    text-align: center;
    padding: 60px;
}

.payment-status p {
    font-size: 14px;
    line-height: 19px;
}

@media (max-width: 1024px) {
    .card-payment .card-content {
        text-align: center;
        padding: 30px;
    }
}
</style>